import type { RouteObject } from "react-router";

import { ErrorPage } from "@/components/Error/ErrorPage";

import { AskNobiChatPage } from "./pages/ask-nobi-chat/AskNobiChatPage";
import { askNobiRoutes } from "./routes";

export const askNobiRoute = [
  {
    path: askNobiRoutes.chat,
    element: <AskNobiChatPage />,
  },
  { path: "*", element: <ErrorPage status={404} /> },
] satisfies RouteObject[];
